<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {

    methods: {
        ...mapMutations({
            SetSelectCycle:'regis_discepline/SetSelectCycle',
            SET_ACTIVITY:'regis_discepline_sidebar/SET_ACTIVITY',
            Setitoc:'regis_discepline/Setitoc',
        }),
        ...mapActions({
            SetComponent:'regis_discepline/SetComponent',
            FetchComponentAction:'regis_discepline/FetchComponent',
        }),
        async fetchComponent(uid,itoc){

            try {
                this.$vs.loading();

                this.SetSelectCycle(uid);
                this.SET_ACTIVITY(false);

                this.SetComponent({ is_clear:true, })
                var params ={}
                var route = this.$route.query
                if(this.is_edvisor){
                    params = {
                        study_year:route.study_year,
                        study_plan:route.study_plan,
                        acad_period:route.acad_period,
                        student:route.student,
                        cycle:uid,
                    }
                }else{
                    params = {
                        study_year:this.filter.study_year.uid,
                        study_plan:this.filter.study_plan.uid,
                        acad_period:this.filter.acad_period.uid,
                        cycle:uid,
                    }
                }
                await this.$http.get('user/component_student_discipline_views/', {
                    params: params}).then(async res=>{

                    if(res.data.length){

                        this.SetComponent({
                            is_clear:false,
                            data:res.data
                        })
                        if (route.student){
                            await this.FetchComponentAction({uid: res.data[0].component, student:route})

                        }else{
                            await this.FetchComponentAction({uid: res.data[0].component})
                        }
                        this.Setitoc(itoc)

                    }

                })


            } catch(e) {
                console.log(e)
            } finally {
                this.$vs.loading.close()
            }
        }
    },
}
</script>
